/*
 * @Author: wangshengqiang
 * @Date: 2021-04-26 16:23:56
 * @LastEditTime: 2021-11-10 14:18:03
 * @LastEditors: wangshengqiang
 * @Description: 投保规则
 */
import React from 'react';
import './index.less';

function DetailV({
  _label,
  label,
  value
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: "cc-detail-v"
  }, /*#__PURE__*/React.createElement("label", null, label || _label), /*#__PURE__*/React.createElement("span", null, value));
}

const HealthInsureRule = props => {
  const {
    attrs
  } = props;
  const {
    dataSource = []
  } = attrs;

  if (dataSource.length === 0) {
    return null;
  }

  return /*#__PURE__*/React.createElement("div", {
    className: "c-insure-rules  bg-fff pr10"
  }, dataSource.map(item => {
    return /*#__PURE__*/React.createElement(DetailV, item);
  }));
};

export default HealthInsureRule;